<div>
  <p style="color: black;padding-top: 10%; text-align: center; font-size: 25px;font-weight: 2000rem;">
    This page has moved to a new place. Redirecting in 5 seconds!
  </p>
</div>

@if (showLoader) {
<div class="loader-container">
  <app-loader style="stroke:  #002677 !important;"></app-loader>
</div>
}
